import { createContext } from 'react';

export const eventContext = createContext({});

export default eventContext;
